import { render, staticRenderFns } from "./page.vue?vue&type=template&id=28f821b2&scoped=true&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=28f821b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f821b2",
  null
  
)

component.options.__file = "page.vue"
export default component.exports